import script from "./maikajilu.vue?vue&type=script&setup=true&lang=js"
export * from "./maikajilu.vue?vue&type=script&setup=true&lang=js"

import "./maikajilu.vue?vue&type=style&index=0&id=972a14c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-972a14c4"]])

export default __exports__